import { render, staticRenderFns } from "./PullRequest.vue?vue&type=template&id=5b59e3a9&scoped=true&"
import script from "./PullRequest.vue?vue&type=script&lang=js&"
export * from "./PullRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59e3a9",
  null
  
)

export default component.exports